import { Link } from "react-router-dom";
import styles from "./PageNotFound.module.scss";
import { background } from "../assets/images";
import { Layout } from "../shared/components/Layout";
import clsx from "clsx";

const PageNotFound = () => {
  return (
    <Layout
      background={background}
      customPlaceholder={styles.placeholder}
      showFooter
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>404</h1>
          <p className={styles.message}>Страница не найдена</p>
          <p className={styles.submessage}>
            Возможно, вы ввели неправильный адрес или страница была удалена.
          </p>
          <Link to="/" className={clsx(styles.homeButton, "wood-theme")}>
            На главную
          </Link>
        </div>
      </div>
    </Layout>
  );
};
export default PageNotFound;
